import React from "react";
import "./Button.css"

export type ButtonProps = 
{
    onClick : (
        event? : any
    ) => void;
    label?: string;
    type?: "login" | "lg"
    color: "white" | "green" | "gray" | "transparent";
    isDisabled?: boolean
}

export type ButtonState = {}

export class Button extends React.Component<ButtonProps, ButtonState> {
    constructor(props: ButtonProps) {
        super(props);
    }

    resolveSizeClass(){
        switch(this.props.type){
            case "login": return "login_btn";
            case "lg": return "lg_btn";
            default : return "";
        }
    }

    resolveColorClass(){
        switch(this.props.color){
            case "white":
                 return "white_btn";
            case "transparent":
                 return "link_btn";
            case "green": 
                return "primary_btn";
            case "gray": 
                return "gray_btn";
        }
    }    

    render() {
        const className = `btn ${this.resolveColorClass()} ${this.resolveSizeClass()}`;

        return  <button className={className} onClick={e => this.props.onClick()} disabled={this.props.isDisabled}>{this.props.label}</button>
    }
}

export type ButtonLinkProps = 
{
    url: string,
    label?: string;
    type?: "login" | "lg"
    color: "white" | "green" | "gray" | "transparent";
    isDisabled?: boolean
}

export class ButtonLink extends React.Component<ButtonLinkProps, ButtonState> {
    constructor(props: ButtonLinkProps) {
        super(props);
    }

    resolveSizeClass(){
        switch(this.props.type){
            case "login": return "login_btn";
            case "lg": return "lg_btn";
            default : return "";
        }
    }

    resolveColorClass(){
        switch(this.props.color){
            case "white":
                 return "white_btn";
            case "transparent":
                 return "link_btn";
            case "green": 
                return "primary_btn";
            case "gray": 
                return "gray_btn";
        }
    }    

    render() {
        const className = `btn ${this.resolveColorClass()} ${this.resolveSizeClass()}`;

        return  <a href={this.props.url}>{this.props.label}</a>
    }
}
